import axios from 'axios';
import config from '../helpers/configProvider';
import { authHeader } from '../helpers';
import { store } from '../store/index';

export default () => {
  const api = axios.create({
    baseURL: config.getEnv(config.enum.VUE_APP_API_SERVICE_URL) || `http://localhost:8081`,
    headers: {
      ...authHeader(),
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });

  api.interceptors.request.use(
    (config) => {
      store.commit('app/incrementRequestInProgress');
      return config;
    },
    (error) => {
      store.commit('app/decrementRequestInProgress');
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => {
      store.commit('app/decrementRequestInProgress');
      return response;
    },
    (error) => {
      store.commit('app/decrementRequestInProgress');
      return Promise.reject(error);
    }
  );

  return api;
};
